import { MainLayout } from "components/layouts";
import NewsForm from "./NewsForm";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Flex, Space } from "antd";

const NewsCreate = (props) => {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("news_policy.header"), href: "/news_policy/news" },
            { title: t("news_list.header"), href: "/news_policy/news" },
            { title: t("common.create") },
          ]} />
          <h2>{t("common.create")}</h2>
        </Flex>
        <NewsForm {...props} />
      </Space>
    </MainLayout>
  );
};

export default NewsCreate;
